import React from 'react'
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';


const PreviewMark = () => {
    const navigate=useNavigate()
  return (
   <div className='preview-bar'>
        <div className="preview-watermark">
           <VisibilityIcon />
           Preview
        </div>
        <div className="close-preview-icon" onClick={()=>navigate("/preview")}>
        <CloseIcon/>
        </div>
    </div>
  )
}

export default PreviewMark